import { TreeTableDesignTokens } from '@primeuix/themes/types/treetable';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const treeTableOverride: TreeTableDesignTokens = {
  headerCell: {
    color: getColor('DarkBlue'),
    background: getColor('Sandstone95'),
    padding: getRem(12),
  },
  bodyCell: {
    padding: getRem(12),
  },
  row: {
    color: getColor('UiBlack'),
  },
  nodeToggleButton: {
    color: getColor('SeaBlue'),
  },
};
